module.exports = __webpack_public_path__ + "media/images/og-image-d842c793858aadceb6b4ba855d784a79.jpg";